import { API_CONFIG, buildApiUrl, getAuthHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

// Types for Lottery API
export interface Lottery {
  id: number;
  date: string;
  looseSales: number;
  bankStart: number;
  bankEnd: number;
  onlineSales: number;
  onlinePdOut: number;
  scratchPdOut: number;
  moneyLeft: number;
  notes: string | null;
  scratchTickets: string | null;
  deposit: number;
  safeWithdrawals: number;
  userId: number;
  createdDate: number;
}

export interface CreateLotteryRequest {
  date?: string;
  looseSales?: number;
  bankStart?: number;
  bankEnd?: number;
  onlineSales?: number;
  onlinePdOut?: number;
  scratchPdOut?: number;
  moneyLeft?: number;
  notes?: string;
  scratchTickets?: string;
  deposit?: number;
  safeWithdrawals?: number;
}

export interface PaginatedLotteryResponse {
  data: Lottery[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface PaginationParams {
  page?: number;
  limit?: number;
}

// Lottery API calls
export const lotteryApi = {
  // Get all lottery entries with pagination
  getLotteryEntries: async (
    params: PaginationParams = {},
    token: string
  ): Promise<PaginatedLotteryResponse> => {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.append('page', params.page.toString());
    if (params.limit) searchParams.append('limit', params.limit.toString());

    const url = `${buildApiUrl(API_CONFIG.ENDPOINTS.LOTTERY.BASE)}?${searchParams.toString()}`;
    
    return apiRequest<PaginatedLotteryResponse>(
      url,
      {
        method: 'GET',
        headers: getAuthHeaders(token),
      }
    );
  },

  // Create new lottery entry
  createLotteryEntry: async (data: CreateLotteryRequest, token: string): Promise<Lottery> => {
    return apiRequest<Lottery>(
      buildApiUrl(API_CONFIG.ENDPOINTS.LOTTERY.BASE),
      {
        method: 'POST',
        headers: getAuthHeaders(token),
        body: JSON.stringify(data),
      }
    );
  },
};

